module.exports = __webpack_public_path__ + "img/b_home_01.37109362.jpg";